import { useEffect, useRef } from 'react';
import { useLiveDealersQuery } from '@features/dealers/hooks/useDealersQuery';

export const useRevokedDealerSelection = (
    dealerId: string | undefined,
    onRevoked: () => void,
    sellingProductId?: string,
) => {
    const { data, isFetchedAfterMount, isError, refetch } = useLiveDealersQuery(
        {
            dealer_ids: dealerId ? [dealerId] : [],
            per_page: 1,
            ...(sellingProductId && { selling_product_id: sellingProductId }),
        },
        { enabled: !!dealerId },
    );
    const isRevoked = !!dealerId && isFetchedAfterMount && !isError && data?.data.length === 0;

    const onRevokedRef = useRef(onRevoked);
    onRevokedRef.current = onRevoked;

    useEffect(() => {
        if (isRevoked) {
            onRevokedRef.current();
        }
    }, [isRevoked]);

    const retry = () => {
        if (dealerId) void refetch();
    };

    return { retry };
};
